import React from 'react';
import { FormattedMessage } from 'react-intl';

import { NotificationService, NOTIFICATION_DURATIONS, NOTIFICATION_TYPE_SUCCESS } from 'ui-components/services/notification-service';

import { messages } from '../messages';

export const onWalletRegistrationSuccess = () => {
  NotificationService.showNotification({
    notificationType: NOTIFICATION_TYPE_SUCCESS,
    title: <FormattedMessage {...messages.registrationSuccessTitle} />,
    content: <FormattedMessage {...messages.registrationSuccessContent} />,
    duration: NOTIFICATION_DURATIONS.SHORT,
  });
};
